import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import BuySellSelector, { OrderMode } from "./BuySellSelector";
import styled from "styled-components";
import SLPPHPConverter from "../converters/SlpPhp";

const CryptoDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CryptoDetailsFC: React.FC = () => {
  const { push } = useHistory();
  const [orderMode, setOrderMode] = useState<OrderMode>("BUY");

  return (
    <CryptoDetailsContainer>
      {/* <h2>What would you like to do?</h2>
      <BuySellSelector value={orderMode} onChange={setOrderMode} /> */}
      <SLPPHPConverter />
      {/* <button onClick={() => push("/")}>Cancel</button> */}
    </CryptoDetailsContainer>
  );
};

const CryptoDetails = React.memo(CryptoDetailsFC);

export default CryptoDetails;
